import React from 'react';
import Img from 'gatsby-image';
import { graphql } from 'gatsby';
import { uid } from 'react-uid';
import Lottie from 'lottie-react-web';
import emailApiAnimation from './emailApiAnimation.json';
import marketingCampaignsAnimation from './marketingCampaignsAnimation.json';
import {
  StyledSuperBlock,
  StyledMedia,
  StyledContent,
  StyledTestimonialContainer
} from './styles';

const GlobalContentBlocksSuperBlock = ({ block }) => {
  return (    
    <StyledSuperBlock layout={block.layout}>
      {block.media.map((media) => {
        const mediaType = media.fieldGroupName.split('_').pop();
        switch (mediaType) {
          case 'Animation':
            const animation = media.lottieAnimation;
            switch (animation) {
              case 'email-api':
                return (
                    <StyledMedia key={uid(media)}>
                      <div className="low-motion-hide" aria-label="Animation demonstrating SendGrid API's language support and email deliverability powers">
                        <Lottie                        
                          options={{
                            animationData: emailApiAnimation,
                            loop: true,
                            rendererSettings: {
                              preserveAspectRatio: 'none'
                            }
                          }}
                          speed = {1}
                        />
                      </div>              
                      <Img
                          className="low-motion-show"
                          fluid={media.fallbackImage.imageFile.childImageSharp.fluid}
                          alt={media.fallbackImage.altText}
                      />
                    </StyledMedia>
                );
                case 'marketing-campaigns':
                  return (
                      <StyledMedia key={uid(media)}>
                        <div className="low-motion-hide" aria-label="Animation demonstrating SendGrid's Marketing Campaign drag-and-drop email builder">
                          <Lottie
                            options={{
                              animationData: marketingCampaignsAnimation,
                              loop: true,
                              rendererSettings: {
                                preserveAspectRatio: 'none'
                              }
                            }}
                            speed = {1}
                          />
                        </div>
                        <Img
                        className="low-motion-show"
                        fluid={media.fallbackImage.imageFile.childImageSharp.fluid}
                        alt={media.fallbackImage.altText}
                        />
                      </StyledMedia>
                  );
                default:
                  return null;
            }
          case 'Image':
            return (
              <StyledMedia key={uid(media)}>
                <Img
                  fluid={media.file.imageFile.childImageSharp.fluid}
                  alt={media.file.altText}
                />
              </StyledMedia>
            );
          default:
            return null;
        }
      })}
      <StyledContent>
        <div className="styled-content__intro">
          <h2 className="is-h3" dangerouslySetInnerHTML={{ __html: block.title }} />
          <p className="styled-content__intro-p" dangerouslySetInnerHTML={{ __html: block.copy }} />  
          <div className="btn-list" style={{justifyContent: 'left'}}>      
            {block.ctaButtons.map((ctaButton) => { 
              const classes = (ctaButton.themeColor === "blue") ? "btn btn--primary" : "btn btn--secondary";
              return (
                  <a
                    type="button"
                    href={ctaButton.url}
                    className={classes}
                    data-gtm-track="true"
                    data-gtm-event-type="cta"
                    key={uid(ctaButton)}
                  >
                    {ctaButton.text}
                  </a>           
              )
            })}
          </div>
        </div>

        {block.testimonial.map((testimonial) => {
          return (
            <StyledTestimonialContainer key={uid(testimonial)}>
              <div>
                {testimonial.logoLink
                  ? <a href={testimonial.logoLink} > 
                      <img
                        src={testimonial.logo.sourceUrl}
                      />
                    </a>              
                  : <img
                      src={testimonial.logo.sourceUrl}
                    />}
                <p className="testimonial__copy" dangerouslySetInnerHTML={{ __html: testimonial.copy}} />
                <p className="testimonial__client-name" dangerouslySetInnerHTML={{ __html: testimonial.clientName}} />
              </div>
            </StyledTestimonialContainer>
          )
        })}

      </StyledContent>   
    </StyledSuperBlock>
  );
};

export default GlobalContentBlocksSuperBlock;

export const query = graphql`
  fragment SuperBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_SuperBlock {
          copy
          fieldGroupName
          title
          testimonial {
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_SuperBlock_Testimonial_Testimonial {
              clientName
              copy
              logo {
                sourceUrl
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 460) {
                      ...GatsbyImageSharpFluid_tracedSVG
                    }
                  }
                }
              }
              logoLink
            }
          }
          media {
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_SuperBlock_Media_Animation {
              fieldGroupName
              lottieAnimation
              fallbackImage {
                sourceUrl
                altText
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 460) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_SuperBlock_Media_Image {
              fieldGroupName
              file {
                sourceUrl
                altText
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 460) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
          layout
          ctaButtons {
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_SuperBlock_CtaButtons_Button {
              fieldGroupName
              text
              themeColor
              url
            }
          }
        }
      }
    }
  }
`;
